import React, { useState } from "react";
import AdminCointainer from "../../containers/Admin";
import { downArrow } from "../../common/svg";
import SecureImage from "../../components/BucketImage/Image";
const Details = () => {
  const [isExpanded, setIsExpanded] = useState(true);
  const toggleExpand = () => setIsExpanded(!isExpanded);

  return (
    <>
      <div className=" mt-2 p-2">
        {/* Collapsible Details Section */}
        <div
  className={` rounded-[20px] border border-[#CBD0D4] transition-all duration-300 ease-in-out overflow-hidden ${
    isExpanded ? "max-h-[500px] p-5" : "max-h-0"
  }`}
>

          <div className="rounded-[20px]">
            <div className="flex items-center justify-between ">
              {/* Booking Details */}
              <div className="text-gray-700 text-sm">
                <p className="text-[#7E7E7E]">Booking</p>
                <p className="font-medium text-[#444FBD]">Zentax</p>
                <p>#29933ST</p>
                <p>Export</p>
              </div>

              {/* Trip Details */}
              <div className="text-gray-700 text-sm ml-20">
                <p className="text-[#7E7E7E]">Trip</p>
                <p className="font-medium text-[#444FBD]">Zentax</p>
                <p>#29933ST</p>
                <p className="whitespace-nowrap">Direct Drop</p>
              </div>

              {/* Eway Bill Details */}
              <div className="text-gray-700 text-sm ml-20">
                <p className="text-[#7E7E7E]">Eway Bill</p>
                <p className="font-medium">657476587567576</p>
                <p>LR Number</p>
                <p className="font-medium">657476587567576</p>
              </div>

              {/* Driver Details */}
              <div className="text-gray-700 text-sm ml-10">
                <p className="text-[#7E7E7E]">Driver</p>
                <p className="font-medium text-[#444FBD] whitespace-nowrap">Praveen Elumalai</p>
                <p className="whitespace-nowrap">+91 8667382199</p>
              </div>

              {/* Transporter Details */}
              <div className="text-gray-700 text-sm ml-10">
                <p className="text-[#7E7E7E]">Transporter</p>
                <p className="font-medium text-[#444FBD] whitespace-nowrap">
                  Kittivaasal Technologies Pvt Ltd
                </p>
                <p>+91 8667382199</p>
                <p>Chennai</p>
              </div>
            </div>
            <div className="grid grid-cols-7 gap-8 text-gray-700 text-sm whitespace-nowrap mt-5">
        {/* RC Number */}
        <div className="mr-5">
          <p className="text-gray-400">RC Number</p>
          <p>657476587567576</p>
        </div>

        {/* Insurance Number */}
        <div className="ml-[60px]">
          <p className="text-gray-400">Insurance Number</p>
          <p>657476587567576</p>
        </div>

        {/* National Permit */}
        <div className="ml-[120px]">
          <p className="text-gray-400">National Permit</p>
          <p className="font-medium">Yes</p>
        </div>

        {/* Type */}
        <div className="ml-[130px]">
          <p className="text-gray-400">Type</p>
          <p className="font-medium">20" Ft</p>
        </div>

        {/* Brand */}
        <div className="ml-20">
          <p className="text-gray-400">Brand</p>
          <p className="font-semibold">Tata</p>
        </div>

        {/* Condition */}
        <div className="ml-10">
          <p className="text-gray-400">Condition</p>
          <p className="font-medium">Good</p>
        </div>

        {/* FC */}
        <div className="ml-5">
          <p className="text-gray-400">FC</p>
          <p className="font-medium">July, 2025</p>
        </div>
      </div>

          </div>
        </div>

        {/* Toggle Button */}
        <div className="flex justify-center items-center mr-5 -top-4 relative">
          <button
            onClick={toggleExpand}
            aria-expanded={isExpanded}
            className="flex justify-center items-center bg-white w-[30px] h-[30px] rounded-full shadow-md"
          >
            {/* <img
              src={downArrow}
              alt={isExpanded ? "Collapse" : "Expand"}
              className={`transition-transform duration-300 ${
                isExpanded ? "rotate-180" : ""
              }`}
            /> */}
                 <SecureImage
              
              fileKey={downArrow}
              alt={isExpanded ? "Collapse" : "Expand"}
              className={`transition-transform duration-300 ${
                isExpanded ? "rotate-180" : ""
              }`}
              width="400px"
            />
          </button>
        </div>
      </div>
    </>
  );
};

export default Details;
